<lib-panel-layout>
  <div class="flex flex-col gap-2">
    <div class="flex gap-2 text-sm lg:flex-col">
      <div class="flex w-full flex-col gap-1.5 rounded-lg border border-ui-primary-border p-1.5">
        <span class="text-white">{{ 'EDITOR.CONTROLS.FLIP' | translate }}</span>
        <div class="flex justify-center gap-2">
          <button
            libButton
            variant="primary"
            size="sm"
            type="button"
            [class.is-pressed]="flipX"
            (click)="flipHor(!flipX)">
            <mat-icon svgIcon="flip_h"></mat-icon>
          </button>
          <button
            libButton
            variant="primary"
            size="sm"
            type="button"
            [class.is-pressed]="flipY"
            (click)="flipVert(!flipY)">
            <mat-icon svgIcon="flip_v"></mat-icon>
          </button>
        </div>
      </div>

      <div class="flex w-full flex-col gap-1.5 rounded-lg border border-ui-primary-border p-1.5">
        <span class="text-white">{{ 'EDITOR.CONTROLS.ROTATE' | translate }}</span>
        <div class="flex justify-center gap-2">
          <button libButton variant="primary" size="sm" type="button" (click)="rotateCCW()">
            <mat-icon svgIcon="rotate_ccw"></mat-icon>
          </button>
          <button libButton variant="primary" size="sm" type="button" (click)="rotateCW()">
            <mat-icon svgIcon="rotate_cw"></mat-icon>
          </button>
        </div>
        <lib-slider
          class="w-full"
          variant="primary"
          [min]="minPreciseAngle"
          [max]="maxPreciseAngle"
          [step]="1"
          [value]="angleValue"
          (changed)="onAngleChanged($event)" />
        <div class="wrap-angle">
          <lib-number-input
            class="max-w-full"
            [label]="'EDITOR.CONTROLS.ANGLE' | translate"
            [value]="angleValue"
            [min]="minPreciseAngle"
            [max]="maxPreciseAngle"
            (changed)="onAngleChanged($event)"
            unit="deg">
          </lib-number-input>
        </div>
        <div class="flex w-full gap-2" role="group">
          <button
            libButton
            type="button"
            class="min-w-0 flex-1"
            [variant]="isCutAdjustment ? 'muted' : 'primary'"
            size="xs"
            (click)="onAdjustmentTypeChanged('fit')">
            {{ 'EDITOR.ROTATE.FIT' | translate }}
          </button>
          <button
            libButton
            type="button"
            class="min-w-0 flex-1"
            [variant]="isCutAdjustment ? 'primary' : 'muted'"
            size="xs"
            (click)="onAdjustmentTypeChanged('cut')">
            {{ 'EDITOR.ROTATE.CUT' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <lib-apply-panel panelActions class="w-full" (apply)="onApply()" (cancelRequested)="onCancel()"> </lib-apply-panel>
</lib-panel-layout>
